import React from "react";
import Button from "./Button";
import { XMarkIcon } from "@heroicons/react/24/solid";

const Modal = ({
  title,
  description,
  toggleModal,
  confirmation,
  handleSubmit,
  submitLabel,
  loading,
  cancelLabel,
  hideCloseIcon,
  leftActions,
  children,
}) => {
  return (
    <div
      className="fixed flex left-0 top-0 z-20 w-full h-screen bg-black bg-opacity-50 backdrop-blur-md items-center justify-center"
      onClick={(e) => {
        if (e.target === e.currentTarget) toggleModal();
      }}
    >
      <div
        className="flex flex-col w-full max-w-full sm:max-w-[500px] md:max-w-[600px] max-h-[95vh] rounded-xl bg-white overflow-hidden"
      >
        <div className="p-[24px] flex flex-col overflow-auto">
          <div className="flex w-full justify-between">
            <div>
              <h2 className="w-full text-[17px]">{title}</h2>
              <p className="text-[14px] font-normal text-[#636C7E]">
                {description}
              </p>
            </div>
            {!hideCloseIcon && (
              <XMarkIcon
                className="size-[24px] cursor-pointer"
                onClick={toggleModal}
              />
            )}
          </div>

          <div className="flex py-[24px]">{children}</div>
          <div className={`flex gap-[8px] ${leftActions ? "w-full justify-between" : ""}`}>
            {leftActions && <div className="flex gap-[8px]">{leftActions}</div>}
            <div className="flex gap-[8px]">
              {handleSubmit && (
                <Button
                  variant="primary"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  {submitLabel ?? "Create"}
                </Button>
              )}
              {confirmation && (
                <Button
                  variant="error"
                  disabled={loading}
                  onClick={() => {
                    confirmation();
                    toggleModal();
                  }}
                >
                  {submitLabel ?? "Confirm"}
                </Button>
              )}
              <Button
                variant="secondary"
                onClick={toggleModal}
                disabled={loading}
              >
                {cancelLabel ?? "Cancel"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
